<template>
    <div id="customer-area" class="fixed-top bg-inverse d-flex justify-content-end align-items-center m-3 ml-auto">

        <span class="mr-1">
            <small class="text-nowrap">{{ __('navigation.customer-area') }}</small>
        </span>

        <span class="icon-user text-white text-center"></span>

    </div>
</template>

<script>
    export default {

        data: function () {
            return {
                //
            }
        },

        mounted: function () {
            //
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #customer-area {
        height: 2.5rem;
        color: white;
        border-radius: 3rem;
        transition: width .4s linear .4s;
        overflow: hidden;
        width: 2.5rem;
        min-width: 2.5rem;

        .circle {
            height: 2.5rem;
            min-width: 2.5rem;
        }

        small {
            opacity: 0;
            display: none;
            transition: opacity .4s;
        }

        .icon-user {
            min-width: 2.5rem;
        }

        &:hover {
            width: 10rem;
            transition: width .4s;

            small {
                opacity: 1;
                display: block;
                transition: opacity .4s linear .4s;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CustomerAreaButton.vue